"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.fetchMap = exports.createStaticMapMachine = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _xstate = require("xstate");
var _querystring = _interopRequireDefault(require("querystring"));
var _States = require("../../lib/constants/States");
const FETCH_CONFIG = {
  credentials: 'same-origin'
};
const onFetchSuccess = (0, _xstate.assign)({
  mapUrls: (_ctx, event) => event.data
});
const onFetchError = (0, _xstate.assign)({
  mapUrls: null,
  error: (_ctx, event) => event
});
const fetchMap = async context => {
  const {
    providerId,
    locationId,
    sizes,
    scale,
    zoom
  } = context;

  // only include params in the api query if they are supplied
  const params = {
    provider_id: providerId,
    locations: locationId,
    sizes: [...new _set.default(sizes)].join(','),
    ...(scale && {
      scale
    }),
    ...(zoom && {
      zoom
    })
  };
  const response = await fetch(`/google-maps/static-map/provider/${providerId}?${_querystring.default.stringify(params)}`, FETCH_CONFIG);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const jsonData = await response.json();
  return jsonData.data;
};
exports.fetchMap = fetchMap;
const machineJSON = () => ({
  id: 'provider-static-map',
  initial: _States.loading,
  context: {
    providerId: null,
    locationId: null,
    sizes: [],
    scale: null,
    zoom: null
  },
  states: {
    [_States.loading]: {
      invoke: {
        src: 'fetchMap',
        onDone: {
          target: _States.idle,
          actions: 'onFetchSuccess'
        },
        onError: {
          target: _States.error,
          actions: 'onFetchError'
        }
      }
    },
    [_States.idle]: {},
    [_States.error]: {}
  }
});
const actions = {
  onFetchSuccess,
  onFetchError
};
const services = {
  fetchMap
};
const makeConfig = () => ({
  actions,
  services
});
exports.makeConfig = makeConfig;
const createStaticMapMachine = _ref => {
  let {
    context,
    config = makeConfig()
  } = _ref;
  return (0, _xstate.Machine)(machineJSON()).withContext(context).withConfig(config);
};
exports.createStaticMapMachine = createStaticMapMachine;